import Image from "next/image";

import { cn, initials } from "@/lib/utils";

interface UserAvatarProps {
  name: string;
  src?: string | null;
  size?: number;
  className?: string;
}

export function UserAvatar({ name, src, size = 40, className }: UserAvatarProps) {
  const isRemote = !!src && (src.startsWith("http://") || src.startsWith("https://"));
  const fallback = !src || src === "/images/default-avatar.png";
  if (fallback) {
    return (
      <span
        className={cn("inline-flex shrink-0 items-center justify-center rounded-full bg-brand/20 font-semibold text-brand", className)}
        style={{ width: size, height: size, fontSize: Math.max(10, size / 2.6) }}
        aria-label={name}
      >
        {initials(name) || "?"}
      </span>
    );
  }
  return (
    <Image
      src={src}
      alt={name}
      width={size}
      height={size}
      unoptimized={isRemote}
      className={cn("shrink-0 rounded-full object-cover", className)}
      style={{ width: size, height: size }}
    />
  );
}
